import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../utils/api";

const STORES_DATA = [
  { name: "Peak Sports Azur City", brand: "PEAK", city: "Ben Arous", phone: "98 172 253" },
  { name: "Peak Sports Mall of Sousse", brand: "PEAK", city: "Sousse", phone: "98 172 252" },
  { name: "Peak Sports Tunis City", brand: "PEAK", city: "Ariana", phone: "98 139 215" },
  { name: "Peak Sports Outlet Tunis City", brand: "PEAK", city: "Ariana", phone: "98 137 589" },
  { name: "Peak Sports Nabeul", brand: "PEAK", city: "Nabeul", phone: "98 172 256" },
  { name: "Peak Sports Tunisia Mall", brand: "PEAK", city: "Tunis", phone: "98 139 125" },
  { name: "Peak Sports La Soukra", brand: "PEAK", city: "Ariana", phone: "98 172 255" },
  { name: "Peak Sports Gabes", brand: "PEAK", city: "Gabes", phone: "53 004 487" },
  { name: "Peak Sports Manar City", brand: "PEAK", city: "Ariana", phone: "98 139 203" },
  { name: "Peak Sports Central Park", brand: "PEAK", city: "Tunis", phone: "98 172 250" },
  { name: "Peak Sports Djerba", brand: "PEAK", city: "Djerba", phone: "98 137 217" },
  { name: "Peak Sports Route Gremda", brand: "PEAK", city: "Sfax", phone: "98 134 914" },
  { name: "Peak Sports Nasreya", brand: "PEAK", city: "Sfax", phone: "98 172 258" },
  { name: "Peak Sports Mall of Sfax", brand: "PEAK", city: "Sfax", phone: "98 137 255" },
  { name: "Peak Sports Av Paris", brand: "PEAK", city: "Tunis", phone: "98 156 529" },
  { name: "Peak Sports Sahloul", brand: "PEAK", city: "Sousse", phone: "" },
  { name: "Anta Sports Tunis City", brand: "ANTA", city: "Ariana", phone: "" },
  { name: "Anta Mall of Sfax", brand: "ANTA", city: "Sfax", phone: "" },
  { name: "Anta Tunisia Mall", brand: "ANTA", city: "Tunis", phone: "" },
];

const EMPTY = {
  store_name: "", zone: "", brand: "", store_director: "",
  inspector: "", visit_date: "", arrival_time: "", departure_time: "",
  visit_type: "Annoncee", affluence: "Moyenne", priority: "Routine",
  staff_planned: "", staff_present: "", staff_absences: "",
};

export default function VisitForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const isEdit = Boolean(id);
  const storesByBrand = form.brand ? STORES_DATA.filter(s => s.brand === form.brand) : [];

  useEffect(() => {
    const user = api.getCurrentUser();
    if (user) {
      setForm(f => ({
        ...f,
        inspector: user.full_name || user.username,
        visit_date: new Date().toISOString().split("T")[0],
      }));
    }
    if (isEdit) { api.getVisit(id).then(v => setForm({ ...EMPTY, ...v })); }
  }, [id]);

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  function onBrandSelect(brand) {
    setForm(f => ({ ...f, brand, store_name: "", zone: "" }));
  }

  function onStoreSelect(storeName) {
    const store = STORES_DATA.find(s => s.name === storeName);
    if (store) {
      setForm(f => ({ ...f, store_name: storeName, zone: store.city, brand: store.brand }));
    }
  }

  async function submit(e) {
    e.preventDefault();
    if (!form.store_name) return alert("Selectionnez une boutique.");
    setSaving(true);
    try {
      const clean = { ...form };
      ["staff_planned", "staff_present"].forEach(k => {
        clean[k] = clean[k] === "" ? null : Number(clean[k]);
      });
      let visit;
      if (isEdit) { visit = await api.updateVisit(id, clean); }
      else { visit = await api.createVisit(clean); }
      navigate(`/visits/${visit.id}/checklist`);
    } finally { setSaving(false); }
  }

  return (
    <div>
      <div className="page-header">
        <h1>{isEdit ? "Modifier la visite" : "Nouvelle visite"}</h1>
        <p>Renseignez les informations de la visite</p>
      </div>
      <form onSubmit={submit}>
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="form-section-title">Identification de la visite</div>
          <div className="form-grid">
            <div className="form-group">
              <label>Marque *</label>
              <select required value={form.brand} onChange={e => onBrandSelect(e.target.value)}>
                <option value="">-- Choisir une marque --</option>
                <option value="PEAK">PEAK</option>
                <option value="ANTA">ANTA</option>
              </select>
            </div>
            <div className="form-group">
              <label>Boutique *</label>
              <select required value={form.store_name} onChange={e => onStoreSelect(e.target.value)}
                disabled={!form.brand} style={{ opacity: !form.brand ? 0.5 : 1 }}>
                <option value="">{form.brand ? `-- Choisir une boutique ${form.brand} --` : "-- Choisissez d abord une marque --"}</option>
                {storesByBrand.map(s => <option key={s.name} value={s.name}>{s.name}</option>)}
              </select>
            </div>
            {form.zone && (
              <div className="form-group">
                <label>Ville</label>
                <input value={form.zone} readOnly style={{ background: "var(--bg)", color: "var(--muted)", cursor: "default" }} />
              </div>
            )}
            <div className="form-group">
              <label>Directeur magasin</label>
              <input value={form.store_director} onChange={e => set("store_director", e.target.value)} placeholder="Nom du directeur" />
            </div>
            <div className="form-group">
              <label>Date de visite</label>
              <input type="date" value={form.visit_date} onChange={e => set("visit_date", e.target.value)} />
            </div>
            <div className="form-group">
              <label>Heure arrivee</label>
              <input type="time" value={form.arrival_time} onChange={e => set("arrival_time", e.target.value)} />
            </div>
            <div className="form-group">
              <label>Heure depart</label>
              <input type="time" value={form.departure_time} onChange={e => set("departure_time", e.target.value)} />
            </div>
            <div className="form-group">
              <label>Type de visite</label>
              <select value={form.visit_type} onChange={e => set("visit_type", e.target.value)}>
                <option value="Annoncee">Annoncee</option>
                <option value="Inopinee">Inopinee</option>
              </select>
            </div>
            <div className="form-group">
              <label>Affluence</label>
              <select value={form.affluence} onChange={e => set("affluence", e.target.value)}>
                <option value="Faible">Faible</option>
                <option value="Moyenne">Moyenne</option>
                <option value="Forte">Forte</option>
              </select>
            </div>
            <div className="form-group">
              <label>Priorite</label>
              <select value={form.priority} onChange={e => set("priority", e.target.value)}>
                <option value="Routine">Routine</option>
                <option value="Corrective">Corrective</option>
                <option value="Urgente">Urgente</option>
              </select>
            </div>
          </div>
        </div>
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="form-section-title">Equipe du jour</div>
          <div className="form-grid">
            <div className="form-group">
              <label>Staff prevu</label>
              <input type="number" min="0" value={form.staff_planned} onChange={e => set("staff_planned", e.target.value)} placeholder="0" />
            </div>
            <div className="form-group">
              <label>Staff present</label>
              <input type="number" min="0" value={form.staff_present} onChange={e => set("staff_present", e.target.value)} placeholder="0" />
            </div>
            <div className="form-group full">
              <label>Absences / retards</label>
              <input value={form.staff_absences} onChange={e => set("staff_absences", e.target.value)} placeholder="Noms et motifs si applicable" />
            </div>
          </div>
        </div>
        <div className="step-actions">
          <button type="button" className="btn btn-outline" onClick={() => navigate("/visits")}>Annuler</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "..." : "Suivant : Grille de controle"}
          </button>
        </div>
      </form>
    </div>
  );
}
